import React, {useState} from 'react';
import Modal from "../../components/modal/modal";
import {Select} from "../../components/ajonjolib/inputs/ajonjolinput";
import {TextInput} from "../../components/input/inputs";
import {toast, ToastTypes} from "../../components/toasts/toast/toast";
import axiosInstance from "../../AxiosInstance";
import {
    afterInvoiceActionSuccess,
    detailFromError,
    rejectFailedResponse,
} from "../bus/afterInvoiceActionSuccess";

export default function RejectModal({show, setter, invoice, name, buttonName}) {
    const [form, setForm] = useState({});
    const [showError, setShowError] = useState(false);

    const options = [
        {value: 1, name: 'Plazo de pago acordado'},
        {value: 2, name: 'Monto neto pendiente de pago'},
        {value: 3, name: 'Reclamo respecto de bienes adquiridos o servicios prestados'}
    ];

    const reject = async () => {
        const selectedReason = form['rejection_reason'];
        const reason = Array.isArray(selectedReason) ? selectedReason[0] : selectedReason;
        const comment = form['rejection_comment'];

        if (!reason) {
            setShowError(true);
            return;
        }

        setShowError(false);
        try {
            await axiosInstance.post('sunat/', {
                ruc_client: invoice.purchase_order.client.ruc,
                ruc_provider: invoice.purchase_order.provider.ruc,
                bill_id: invoice.id,
                conformity: 2,
                motives: reason,
                comment: comment
            }).then(rejectFailedResponse);
            await axiosInstance.put(`bill_status/${invoice.id}/`, {
                status: 3
            }).then(rejectFailedResponse);
            toast('Factura Rechazada', ToastTypes.ERROR);
            afterInvoiceActionSuccess(setter);
        } catch (error) {
            console.error(error);
            toast(detailFromError(error, 'No se pudo rechazar la factura.'), ToastTypes.ERROR);
        }
    }

    return (
        <Modal show={show} setter={setter} onClick={() => reject()} name={'Rechazar'} buttonName={'Rechazar'}>
            <div className={'mb-3'}>¿Seguro que deseas rechazar el documento {invoice?.sn}?</div>
            <div>Motivo de rechazo:</div>
            <Select options={options} value={form['rejection_reason']} onChange={(value) => setForm({...form, rejection_reason: value})}/>
            <div className={'mb-2'}/>
            <div>Comentario:</div>
            <TextInput value={form['rejection_comment']} internalName={'rejection_comment'} form={form} setForm={setForm}/>
            <div className={'mb-3'}/>
            {showError && (
                <div style={{color: "#F00"}}>Por favor seleccionar motivo de rechazo</div>
            )}
        </Modal>
    )
}
